module.exports = __webpack_public_path__ + "img/michael.1082dc7d.jpeg";